import { Text } from "@shopify/polaris";

const ColoredGoogleIcon = () => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {/* Inline SVG for Google logo */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 58 58"
        style={{ display: "inline-block" }}
      >
        <path
          fill="#EA4335"
          d="M24 9.5c3.9 0 6.7 1.6 8.3 2.9l6.2-6.2C34.4 3 29.9 1 24 1 14.7 1 7 6.7 3.7 14.2l7.5 5.8C12.8 13.4 17.7 9.5 24 9.5z"
        />
        <path
          fill="#4285F4"
          d="M47.6 24.3c0-1.6-.1-3.2-.4-4.8H24v9.1h13.3c-.6 3.4-2.5 6.3-5.4 8.2l8.4 6.5c4.9-4.6 7.7-11.5 7.7-19z"
        />
        <path
          fill="#FBBC05"
          d="M10.2 28.3c-.4-1-.6-2.1-.6-3.3s.2-2.3.6-3.3l-7.5-5.8C1.6 17.4 0 20.6 0 24s1.6 6.6 4.3 9.1l7.5-5.8z"
        />
        <path
          fill="#34A853"
          d="M24 47c6.5 0 11.9-2.1 15.9-5.8l-8.4-6.5c-2.3 1.5-5.2 2.4-8.4 2.4-6.4 0-11.8-4.3-13.7-10.1l-7.5 5.8C7 41.3 14.7 47 24 47z"
        />
        <path fill="none" d="M0 0h48v48H0z" />
      </svg>
    </div>
  );
};

export default ColoredGoogleIcon;
